export default __webpack_public_path__ + "static/media/group-8806.2b01fc42.png";